import { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { PdpState } from '@ff-os/pdp-shared-redux/store';

interface DragState {
  isPhotoFunProcessing: boolean;
  canHaveBorderDraggedInto: boolean;
}

const dragSelector = createSelector(
  [
    (state: PdpState) => state.ui.general.isPhotoFunProcessing,
    (state: PdpState) => state.ui.general.canHaveBorderDraggedInto
  ],
  (isPhotoFunProcessing, canHaveBorderDraggedInto): DragState => ({
    isPhotoFunProcessing,
    canHaveBorderDraggedInto
  })
);

export const useDragState = () => {
  return useSelector(dragSelector, shallowEqual);
};

export const usePreventRenderDuringDrag = <T,>(value: T): T => {

  const { isPhotoFunProcessing } = useDragState();

  return useMemo(() => value, [value, isPhotoFunProcessing]);
};